export default __webpack_public_path__ + "static/media/spinner.58c40e0b.svg";